import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

export const state = {
  // ---- ---- 페이징 정보 저장 ---- ----
  condition: {
    searchFlag: false,
    searchText: '',
    searchType: '',
    familyCode: '',
    isInside: false,
    userNo: '',
    ...defaultPaging
  },

  backgroundPreViewImage: '',

  churchCondition: {
    churchNo: '',
    isInside: false,
    ...defaultPaging
  },
  commentCondition: {
    memorialNo: '',
    page: 1,
    limit: 20
  },
  aliveCondition: {
    memorialNo: '',
    ...defaultPaging
  },
  historyCondition: {
    familyCode: '',
    ...defaultPaging
  },
  // ---- ---- 페이징 정보 저장 종료 ---- ----
  // ---- ---- 상세 정보 구간 ---- ----
  detail: {
    memorialNo: '',
    churchNo: '',
    userNo: '',
    memorialType: '',
    familyCode: '',
    deadName: '',
    churchJob: '',
    birthDate: '',
    deathDate: '',
    church: ''
  },
  aliveDetail: {
    aliveNo: '',
    memorialNo: '',
    userNo: '',
    familyCode: '',
    title: '',
    contents: '',
    isActive: '',
    regDate: '',
    files: []
  },

  // ---- ---- 상세 정보 구간 종료 ---- ----
  // ---- ---- 데이터 추가 구간 ---- ----
  register: {
    step1: {
      itemHistoryNo: '',
      memorialType: '',
      isInside: false,
      isBenefit: true,
      isCouple: false
    },
    step2: [
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      },
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      }
    ],
    step3: [
      {
        title: '',
        contents: '',
        date: '',
        targets: []
      }
    ],
    step4: {
      title: '',
      backgroundImageNo: '',
      frameNo: '',
      backgroundFile: '',
      userNo: '',
      familyCode: '',
      churchNo: ''
    }
  },
  aliveRegister: {
    memorialNo: '',
    title: '',
    contents: '',
    firstRawFile: '',
    secondRawFile: ''
  },
  // ---- ---- 데이터 추가 구간 종료 ---- ----
  // ---- ---- List 정보 ---- ----
  memorials: [],
  churchMemorials: [],
  memorialCommentList: [],
  aliveList: [],
  historyList: [],
  // ---- ---- List 정보 종료 ---- ----

  pageInfo: { ...defaultPageInfo },
  churchPageInfo: { ...defaultPageInfo },
  alivePageInfo: { ...defaultPageInfo },
  historyPageInfo: { ...defaultPageInfo },
  memorialType: '', // MEMORIAL_TYPE.INSIDE / OUTSIDE
  isMore: false, // 메인 -> 더보기로 추모관시 접근여부 체크하기 위함,
  backgroundList: [],
  frameList: [],

  anniversaryList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
